(ns common.schema.entities.kpi-report-data
  (:require [common.schema.schema-utils :as su]
            [common.kpis :as kpis]
            ))

(def kpi-report-data-types [{:key   :forecast
                             :label "Forecast"}
                            {:key   :actual
                             :label "Actual"}])
(def schema
  (vec (concat (su/keyword-field :kpi-report-data/kpi "KPI" kpis/kpi-options {:authorization su/access-user-ssg})
               (su/single-ref-field :kpi-report-data/kpi-report "Report" [:entity.type/kpi-report] {:authorization su/access-user-ssg})
               (su/integer-field :kpi-report-data/month "Month" {:authorization su/access-user-ssg})
               (su/integer-field :kpi-report-data/year "Year" {:authorization su/access-user-ssg})
               (su/integer-field :kpi-report-data/period "Period" {:authorization su/access-user-ssg})
               (su/keyword-field :kpi-report-data/type "Type" kpi-report-data-types {:authorization su/access-user-ssg})
               (su/currency-value-field :kpi-report-data/value "Value" {:authorization su/access-ssg-ssg})
               )))
